import clazzRouter from '@/apps/clazz-assessment/main'
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import router from '../../main'
import { checkPrivate } from '../../model/api'
import OperationGuide from '../opreation-guide'
const CLAZZ_MENU = clazzRouter.slice(0, 4)
const menu = router.slice(0, 5)

@Component({
  components: { OperationGuide }
})
export default class SecondTop extends Vue {
  @Prop() public isClazz!: boolean
  // 学科箭头指向
  private down = true
  // 菜单
  private menu = this.isClazz ? CLAZZ_MENU : menu
  // popover是否可见
  private visible = false
  private opVisible = false
  // 获取当前模块名称
  private get curModuleName() {
    return this.$route.meta.name
  }
  private get newAssessmentor() {
    return this.$store.state.newAssessmentor
  }
  // 获取学科
  private get subject() {
    return this.$store.state.subject
  }
  // 获取支持的学科
  private get supportSubjects() {
    const support = this.isClazz ? this.$store.state.clazzSupportSubjects  : this.$store.state.supportSubjects

    let xx: any = {
      label: '小学',
      subs: []
    }
    let cz: any = {
      label: '初中',
      subs: []
    }
    let gz: any = {
      label: '高中',
      subs: []
    }

    for (let n of support) {
      if (/^1\d{2}$/.test(n.value)) {
        xx.subs.push(n)
      } else if (/^2\d{2}$/.test(n.value)) {
        cz.subs.push(n)
      } else if (/^3\d{2}$/.test(n.value)) {
        gz.subs.push(n)
      }
    }
    return [xx, cz, gz]
  }
  private isPrivateSchool = false

  @Watch('newAssessmentor', { immediate: true })
  public onAssessmentorChange(val) {
    this.opVisible = val
  }

  public created() {
    this.checkPrivate()
  }
  // 选取校级测评还是班级测评
  public trackSelectMenu(params) {
    window['sensors'].track('TIKU_Assessment_expo', params)
  }
  // 选择学科
  private selectSubject(sub) {
    this.$store.commit('SET_SUBJECT', sub)
  }
  // 选取
  private selectItem(item: any) {
    // 采集点击事件
    const buttonName = item && item.meta && item.meta.name
    this.trackSelectMenu({ buttonName })
    setTimeout(() => {
      try {
        this.$router.push({ path: item.path })
      } catch(e) {
        console.log(e)
      }
    }, 100)
  }
  private introducing() {
    window.open('/assessment/intro')
  }
  private guide() {
    this.opVisible = true
  }
  private closePopover() {
    this.visible = false
  }
  private cancel() {
    const popref: any = this.$refs.popTip
    console.log(popref);
    if (this.newAssessmentor) {
      popref && popref.click()
    }
    this.opVisible = false
    this.$store.commit('SET_NEW_ASSESSMENTOR', false)
  }
  private async checkPrivate() {
    const data: any = await checkPrivate({})
    if (data.success) {
      this.isPrivateSchool = data.isPrivateSchool
      this.$store.commit('SET_IS_PRIVATESCHOOL', this.isPrivateSchool)
      // 上传权限只有私海教师有
      if (this.$route.name === 'assessmentupload' && !this.isPrivateSchool) {
        this.$router.replace({ path: '/403' })
      }
    } else {
      this.$store.commit('SET_IS_PRIVATESCHOOL', false)
    }
  }
  private showTab(item) {
    if (!item.meta.private) {
      return true
    } else {
      return this.isPrivateSchool
    }
  }
}
